export default __webpack_public_path__ + "static/media/gingerbread.a97a821b.svg";